import { render, staticRenderFns } from "./SettingsAccountDetails.vue?vue&type=template&id=7836c43a&scoped=true&"
import script from "./SettingsAccountDetails.vue?vue&type=script&lang=js&"
export * from "./SettingsAccountDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7836c43a",
  null
  
)

export default component.exports